import { usePatient } from 'hooks/usePatient/usePatient';
import { Lab } from 'kb-shared';

const useHomeMarket = (): Lab => {
  const { patient } = usePatient();
  return { ...patient?.lab } as Lab;
};

export { useHomeMarket };

export default useHomeMarket;
